import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-3 col-md-4" }
const _hoisted_3 = { class: "col-xl-8 col-lg-9 col-md-8" }
const _hoisted_4 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap border-bottom pb-3 mb-4" }
const _hoisted_7 = { class: "d-flex position-relative top-3" }
const _hoisted_8 = { class: "pe-0 border-0 bg-transparent ms-4 ps-2" }
const _hoisted_9 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_10 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_11 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-12" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "d-flex flex-wrap gap-3 align-items-center" }
const _hoisted_17 = { class: "position-relative top-3 d-flex align-items-baseline flex-wrap gap-sm-0" }
const _hoisted_18 = { class: "p-0 border-0 bg-transparent" }
const _hoisted_19 = { class: "p-0 border-0 bg-transparent ms-3" }
const _hoisted_20 = { class: "p-0 border-0 bg-transparent ms-3" }
const _hoisted_21 = { class: "p-0 border-0 bg-transparent ms-3" }
const _hoisted_22 = { class: "p-0 border-0 bg-transparent ms-3" }
const _hoisted_23 = { class: "p-0 border-0 bg-transparent ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSidebar = _resolveComponent("EmailSidebar")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EmailSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "fs-16 fw-semibold mb-0" }, "New Message", -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_8, _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " archive ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Archive',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " help_clinic ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Help',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " delete ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Trash',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [
                _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-11e3fcc3><i class=\"material-symbols-outlined fs-20 text-body hover\" data-v-11e3fcc3> more_vert </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-11e3fcc3><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"eye\" data-v-11e3fcc3></i> View All </a></li><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"trash-2\" data-v-11e3fcc3></i> Delete One </a></li><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"lock\" data-v-11e3fcc3></i> Block </a></li></ul>", 2)
              ]))), [
                [
                  _directive_b_tooltip,
                  'More_Option',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ])
            ])
          ]),
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_12, [
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"col-lg-6\" data-v-11e3fcc3><div class=\"form-group mb-4\" data-v-11e3fcc3><label class=\"label text-secondary fs-14\" data-v-11e3fcc3>To</label><select class=\"form-select form-control h-55\" aria-label=\"Default select example\" data-v-11e3fcc3><option selected data-v-11e3fcc3>To</option><option value=\"1\" data-v-11e3fcc3>james@trezo.com</option><option value=\"2\" data-v-11e3fcc3>andy@trezo.com</option><option value=\"3\" data-v-11e3fcc3>mateo@trezo.com</option><option value=\"4\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"5\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"6\" data-v-11e3fcc3>tomato@trezo.com</option></select></div></div><div class=\"col-lg-6\" data-v-11e3fcc3><div class=\"form-group mb-4\" data-v-11e3fcc3><label class=\"label text-secondary fs-14\" data-v-11e3fcc3>Cc</label><select class=\"form-select form-control h-55\" aria-label=\"Default select example\" data-v-11e3fcc3><option selected data-v-11e3fcc3>Cc</option><option value=\"1\" data-v-11e3fcc3>james@trezo.com</option><option value=\"2\" data-v-11e3fcc3>andy@trezo.com</option><option value=\"3\" data-v-11e3fcc3>mateo@trezo.com</option><option value=\"4\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"5\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"6\" data-v-11e3fcc3>tomato@trezo.com</option></select></div></div><div class=\"col-lg-6\" data-v-11e3fcc3><div class=\"form-group mb-4\" data-v-11e3fcc3><label class=\"label text-secondary fs-14\" data-v-11e3fcc3>Bcc</label><select class=\"form-select form-control h-55\" aria-label=\"Default select example\" data-v-11e3fcc3><option selected data-v-11e3fcc3>Bcc</option><option value=\"1\" data-v-11e3fcc3>james@trezo.com</option><option value=\"2\" data-v-11e3fcc3>andy@trezo.com</option><option value=\"3\" data-v-11e3fcc3>mateo@trezo.com</option><option value=\"4\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"5\" data-v-11e3fcc3>luca@trezo.com</option><option value=\"6\" data-v-11e3fcc3>tomato@trezo.com</option></select></div></div><div class=\"col-lg-6\" data-v-11e3fcc3><div class=\"form-group mb-4\" data-v-11e3fcc3><label class=\"label text-secondary fs-14\" data-v-11e3fcc3>Subject</label><input type=\"text\" class=\"form-control h-55\" placeholder=\"Write your subject...\" data-v-11e3fcc3></div></div>", 4)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label text-secondary fs-14" }, "Description", -1)),
                  _createVNode(_component_TextEditor, { class: "text-editor" })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[13] || (_cache[13] = _createElementVNode("button", {
                    class: "btn btn-primary text-white fw-semibold py-2 px-4 me-4",
                    type: "submit"
                  }, " Send ", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, _cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " text_fields_alt ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'Text',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_19, _cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " attach_file ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'File',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_20, _cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " link ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'Link',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_21, _cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " mood ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'Mood',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_22, _cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " add_to_drive ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'Drive',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_23, _cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " ink_pen ", -1)
                    ]))), [
                      [
                        _directive_b_tooltip,
                        'Pen',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"dropdown action-opt ms-3 position-relative top-2\" data-v-11e3fcc3><button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-11e3fcc3><i class=\"material-symbols-outlined fs-20 text-body hover\" data-v-11e3fcc3> more_vert </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" style=\"bottom:30px;\" data-v-11e3fcc3><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"eye\" data-v-11e3fcc3></i> View All </a></li><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"trash-2\" data-v-11e3fcc3></i> Delete One </a></li><li data-v-11e3fcc3><a class=\"dropdown-item\" href=\"javascript:;\" data-v-11e3fcc3><i data-feather=\"lock\" data-v-11e3fcc3></i> Block </a></li></ul></div>", 1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}